import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=6df5865f&scoped=true"
import script from "./inbox.vue?vue&type=script&lang=js"
export * from "./inbox.vue?vue&type=script&lang=js"
import style0 from "./inbox.vue?vue&type=style&index=0&id=6df5865f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df5865f",
  null
  
)

export default component.exports